import { useNotifications, IMessage } from '@novu/notification-center'
import { Button, Dropdown, Typography, Icons, Badge } from '@pankod/refine-antd'
import React, { useContext } from 'react'
import { List, message } from 'antd'
import VirtualList from 'rc-virtual-list'
import { useUserContext } from 'context/user'
import { useNavigation } from '@pankod/refine-core'
import { useNavigate } from 'react-router-dom'
import { transformOldNotification } from 'helpers'

const { BellOutlined } = Icons
const { Text } = Typography

interface CustomNotificationProps {
  oldNotifications: any
}

const CustomNotifications: React.FC<CustomNotificationProps> = ({ oldNotifications }) => {
  const { push, replace } = useNavigation()
  const { notifications, markAllNotificationsAsSeen, markNotificationAsRead, markNotificationAsSeen } = useNotifications()
  const { userRole } = useUserContext()
  const filternotifications: any[] = notifications?.filter((notification: any) => notification?.payload?.role === userRole)

  const onNotificationClick = (message: IMessage) => {
    // your logic to handle the notification click
    if (message?.cta?.data?.url) {
      const pathname = new URL(message?.cta?.data?.url).pathname
      push(pathname)
    }
  }

  const oldNotificationClick = (data: any) => {
    replace('/' + data?.source_name + '/' + data?.redirect_component + '/' + data?.redirect_id)
  }

  const onNotificationRS = async (messageId: string) => {
    await Promise.all([markNotificationAsRead(messageId), markNotificationAsSeen(messageId)])
  }
  // merge notifications
  const mergenotifications: any = filternotifications?.concat(oldNotifications)
  console.log('mergenotifications', mergenotifications, mergenotifications?.length)
  const notify =
    mergenotifications?.length > 0 ? (
      <List
        style={{
          width: '400px',
          paddingLeft: '20px',
          paddingTop: '12px',
          paddingRight: '20px',
          background: '#fff',
          boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        }}
      >
        {/* <span
          style={{
            fontWeight: 'bold',
            cursor: 'pointer',
          }}
          // onClick={() => markAllNotificationsAsRead()}

        >
          Mark All as Read
        </span> */}
        <VirtualList data={mergenotifications} height={200} itemHeight={47} itemKey="id">
          {(item: any) => (
            <List.Item
              key={item.id}
              onClick={item?.is_old === true ? () => oldNotificationClick(item) : () => onNotificationClick(item)}
              // onClick={() => onNotificationClick(item)}
            >
              <List.Item.Meta
                // title={<a onClick={() => updateNotification(item)}>{`${item.title} - from ${item?.sender_details?.displayName}`}</a>}
                description={
                  <span
                    style={{
                      color: item?.read === false ? 'black' : undefined,
                      cursor: 'pointer',
                    }}
                    onClick={() => onNotificationRS(item?.id)}
                  >
                    {item?.content}
                  </span>
                }
              />
            </List.Item>
          )}
        </VirtualList>
      </List>
    ) : (
      <List style={{ width: '200px', paddingLeft: '20px', background: '#fff', boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px' }}>
        <List.Item key={'no-data'}>
          <List.Item.Meta title={<Text type="warning">No Notifications</Text>} description={''} />
        </List.Item>
      </List>
    )

  return (
    <>
      <Dropdown overlay={notify} placement="bottomLeft">
        <div style={{ margin: '0 20px' }} onClick={() => markAllNotificationsAsSeen()}>
          <Badge count={mergenotifications?.length ?? 0} className="site-badge-count" style={{ backgroundColor: '#6659FF' }}>
            <Button
              icon={<BellOutlined />}
              style={{ fontSize: 'larger', border: 'none', color: 'black', background: 'transparent', boxShadow: 'none' }}
            />
          </Badge>
        </div>
      </Dropdown>
    </>
  )
}

export default CustomNotifications
